import styled from 'styled-components';

export const BannerListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
